export default "__VITE_ASSET__x5x9xzuw__"